import crypto from 'crypto-js';

export const encrypt = (data) => crypto.AES.encrypt(JSON.stringify(data),process.env.REACT_APP_SECRET_KEY);

export const decrypt = (data) => {
 const bytes = crypto.AES.decrypt(data, process.env.REACT_APP_SECRET_KEY)
 const decryptedData = JSON.parse(bytes.toString(crypto.enc.Utf8));
 return decryptedData;
}